import React, { lazy } from 'react';
import { contactHistoryColumns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));

const ContractHistory = ({ Styled, contractHistoryList, i18n }) => {
  const information = i18n.t('common.tableEmptyMessage');

  return (
    <Styled.TableWrapper>
      <SubHeader variant="h2" className="contractHistorytitle" text={i18n.t('paymentInformation.contractHistory')} />
      <div className="contractHistory tcSection" id="scroll">
        <div className="scrollbar">
          <Table
            type="client"
            defaultSortBy={{ sortBy: 'startDate', order: 'asc' }}
            title=""
            columns={contactHistoryColumns}
            data={contractHistoryList || []}
            emptyMessage={information}
            i18n={i18n}
            actions={[]}
            itemsPerPage={contractHistoryList?.length}
          />
        </div>
      </div>
    </Styled.TableWrapper>
  );
};

export default ContractHistory;
